module.exports = __webpack_public_path__ + "img/amx-8.dbaa35b6.webp";